import { Message } from "@/types/chat";
import DebiasedHighlightedText from "@/components/DebiasedHighlightedText";

interface ChatOutputProps {
    messages: Message[];
    isLoading: boolean;
}

export default function ChatOutput({ messages, isLoading }: ChatOutputProps) {
    // Filter only assistant messages for the output column
    const assistantMessages = messages.filter(
        (msg) => msg.role === "assistant"
    );

    return (
        <div className="flex-1 flex flex-col">
            {/* Header */}
            <div className="p-4 border-b border-gray-200">
                <h3 className="text-lg font-bold">Αμερόληπτο κείμενο</h3>
                <p className="text-sm font-light">
                    Το Fairlegal επιστρέφει το κείμενο ή το έγγραφο σας έχοντας εντοπίσει και εξαλείψει την μεροληψία λόγω φύλου σε νομικά και διοικητικά κείμενα του δημόσιου και ιδιωτικού τομέα.
                </p>
            </div>

            {/* Content Area */}
            <div className="flex-1 overflow-y-auto p-4">
                <div className="space-y-6">
                    {assistantMessages.length > 0 ? (
                        assistantMessages.map((message) => (
                            <div
                                key={message.id}
                                className="bg-blue-50 border border-blue-200 rounded-lg p-4"
                            >
                                <div className="flex items-start space-x-3">
                                    {/* AI Icon */}
                                    <div className="flex-shrink-0">
                                        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                                            <svg
                                                className="w-5 h-5 text-white"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                                />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* Message Content */}
                                    <div className="flex-1">
                                        <div className="text-sm text-gray-800 leading-relaxed">
                                            {message.debiasSourceText ? (
                                                <DebiasedHighlightedText
                                                    debiased={message.content}
                                                    original={
                                                        message.debiasSourceText
                                                    }
                                                />
                                            ) : (
                                                message.content
                                            )}
                                        </div>
                                        <div className="text-xs text-gray-500 mt-2">
                                            {message.timestamp.toLocaleTimeString(
                                                "el-GR",
                                                {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-8 py-44">
                            {/* <div className="max-w-md mx-auto">
                                <div className="text-gray-400 mb-4">
                                    <svg
                                        className="w-16 h-16 mx-auto"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={1}
                                            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                        />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-700 mb-2">
                                    Εκκρεμεί απάντηση
                                </h3>
                                <p className="text-gray-600">
                                    Οι απαντήσεις θα εμφανίζονται εδώ
                                </p>
                            </div> */}
                        </div>
                    )}

                    {/* Loading indicator */}
                    {isLoading && (
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <div className="flex items-start space-x-3">
                                <div className="flex-shrink-0">
                                    <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                                        <svg
                                            className="w-5 h-5 text-white"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center space-x-2">
                                        <div className="flex space-x-1">
                                            <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"></div>
                                            <div
                                                className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"
                                                style={{
                                                    animationDelay: "0.1s",
                                                }}
                                            ></div>
                                            <div
                                                className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"
                                                style={{
                                                    animationDelay: "0.2s",
                                                }}
                                            ></div>
                                        </div>
                                        <span className="text-sm text-blue-600">
                                            Γράφει...
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
